import { Box, Button, Divider, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import EmptyStar from "../../../../SVGs/EmptyStar";
import CommentInput from "./CommentInput";
import CommentItem from "./CommentItem";

function Comments({ loadMoreComments }) {
  const postId = useParams()?.id;

  const comments = useSelector((s) => s?.video?.data?.byId);
  const allIds = useSelector((s) => s?.video?.data?.allIds);
  const loading = useSelector((s) => s?.video?.loading);
  const count = useSelector((s) => s?.video?.count);
  const thisPage = useSelector((s) => s?.video?.thisPage);
  const allPages = useSelector((s) => s?.video?.allPages);
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "1em",
        padding: "2em",
        backgroundColor: "#FAFAFA",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "1em",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "#323232",
            }}
          >
            Comments
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "#6C6C6C",
            }}
          >
            {count} Comment
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#F3F3F3",
          borderRadius: "10px",
        }}
      >
        {allIds?.map((commentId) => {
          let comment = comments[commentId];
          let creator = comment?.creator;

          return (
            <>
              <CommentItem
                image={creator?.image}
                name={
                  creator?.firstName + creator?.lastName || creator?.username
                }
                color={creator?.color}
                comment={comment?.text}
                star={<EmptyStar />}
                likes={"0"}
                data={comment}
                id={comment?.id}
              />
              <Divider
                variant="middle"
                sx={{
                  height: "1px",
                  backgroundColor: "white",
                  borderColor: "white",
                }}
              />
            </>
          );
        })}

        {isAuthenticated && <CommentInput postId={postId} />}
      </Box>
      {thisPage < allPages && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            disabled={loading}
            sx={{
              fontSize: "14px",
              color: "#323232",
              transition: "0.5s all",
              "&:hover": {
                color: "white",
                backgroundColor: "#25AAE1",
              },
            }}
            onClick={loadMoreComments}
          >
            See More
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default Comments;
